﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LLVaultManagerABI = void 0;
class LLVaultManagerABI {
    static GetABI() {
        return [
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "key",
                        "type": "address"
                    }
                ],
                "name": "Vaults",
                "outputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "debt",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "coll",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "stake",
                                "type": "uint256"
                            },
                            {
                                "internalType": "enum ILLVaultManager.Status",
                                "name": "status",
                                "type": "uint8"
                            },
                            {
                                "internalType": "uint128",
                                "name": "arrayIndex",
                                "type": "uint128"
                            }
                        ],
                        "internalType": "struct ILLVaultManager.Vault",
                        "name": "",
                        "type": "tuple"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "addVaultOwnerToArray",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "index",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "applyPendingRewards",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address[]",
                        "name": "_vaultArray",
                        "type": "address[]"
                    }
                ],
                "name": "batchLiquidateVaults",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "borrowerOperationsAddress",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_price",
                        "type": "uint256"
                    }
                ],
                "name": "checkRecoveryMode",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "closeVault",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "decayBaseRateFromBorrowing",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_collDecrease",
                        "type": "uint256"
                    }
                ],
                "name": "decreaseVaultColl",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_collDecrease",
                        "type": "uint256"
                    }
                ],
                "name": "decreaseVaultDebt",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "LUSDDebt",
                        "type": "uint256"
                    }
                ],
                "name": "getBorrowingFee",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_LUSDDebt",
                        "type": "uint256"
                    }
                ],
                "name": "getBorrowingFeeWithDecay",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getBorrowingRate",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getBorrowingRateWithDecay",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_price",
                        "type": "uint256"
                    }
                ],
                "name": "getCurrentICR",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "getEntireDebtAndColl",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "debt",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "coll",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "pendingLUSDDebtReward",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "pendingETHReward",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "getNominalICR",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "getPendingETHReward",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "getPendingLUSDDebtReward",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_ETHDrawn",
                        "type": "uint256"
                    }
                ],
                "name": "getRedemptionFeeWithDecay",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getRedemptionRate",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getRedemptionRateWithDecay",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_price",
                        "type": "uint256"
                    }
                ],
                "name": "getTCR",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "getVaultColl",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "getVaultDebt",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_index",
                        "type": "uint256"
                    }
                ],
                "name": "getVaultFromVaultOwnersArray",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getVaultOwnersCount",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "getVaultStake",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "getVaultStatus",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "hasPendingRewards",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_collIncrease",
                        "type": "uint256"
                    }
                ],
                "name": "increaseVaultColl",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_debtIncrease",
                        "type": "uint256"
                    }
                ],
                "name": "increaseVaultDebt",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "liquidate",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_n",
                        "type": "uint256"
                    }
                ],
                "name": "liquidateVaults",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "lqtyStaking",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "lqtyToken",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_LUSDAmount",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "_firstRedemptionHint",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "_upperPartialRedemptionHint",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "_lowerPartialRedemptionHint",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_partialRedemptionHintNICR",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_maxIterations",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "_maxFee",
                        "type": "uint256"
                    }
                ],
                "name": "redeemCollateral",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "removeStake",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "num",
                        "type": "uint256"
                    }
                ],
                "name": "setVaultStatus",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "stabilityPool",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "updateStakeAndTotalStakes",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "_borrower",
                        "type": "address"
                    }
                ],
                "name": "updateVaultRewardSnapshots",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "usdlToken",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            }
        ];
    }
}
exports.LLVaultManagerABI = LLVaultManagerABI;
//# sourceMappingURL=LLVaultManagerABI.js.map